/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Meta_TitleInputs */

const en_svc_agents_meta_title = /** @type {(inputs: Svc_Agents_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Agent Development — Custom AI Agents for Business | Lindevo`)
};

const lv_svc_agents_meta_title = /** @type {(inputs: Svc_Agents_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI aģentu izstrāde uzņēmumiem — pielāgoti AI aģenti | Lindevo`)
};

/**
* | output |
* | --- |
* | "AI Agent Development — Custom AI Agents for Business \| Lindevo" |
*
* @param {Svc_Agents_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_meta_title = /** @type {((inputs?: Svc_Agents_Meta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Meta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_meta_title(inputs)
	return en_svc_agents_meta_title(inputs)
});